// QR Kiosk v2 — 1:1 dashboard skeleton (bug #13). Mirrors the real §3.3 stack
// block-for-block with identical margins/heights/radii. Pass 1b 2026-07-24:
// header (78×58 image, taller lines) → 64px fault CTA → 3 stable grid tiles at
// 112px (the 4th, my-tasks, is conditional-late in the real board; the gold
// MIDAS bar is DELETED per §1b.2) → composer dock. NO account row, NO pill
// placeholder, NO chips row (conditional in the real dock). Shimmer only, no
// entrance animation. Tokens only.
import React from "react";
import { SkeletonBlock } from "../shared/SkeletonBlocks";

export function DashboardSkeleton() {
  return (
    <>
      {/* 1 · header card */}
      <div
        style={{
          margin: "12px 14px 0",
          background: "var(--card)",
          border: "1px solid var(--border)",
          borderRadius: 12,
          overflow: "hidden",
          flexShrink: 0,
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 14, padding: "14px" }}>
          <SkeletonBlock w={78} h={58} r={8} style={{ flexShrink: 0 }} />
          <div style={{ minWidth: 0, flex: 1 }}>
            <SkeletonBlock w="60%" h={17} />
            <SkeletonBlock w="45%" h={13} style={{ marginTop: 6 }} />
            <SkeletonBlock w="32%" h={11} style={{ marginTop: 6 }} />
          </div>
        </div>
      </div>

      {/* 2 · XL fault button */}
      <SkeletonBlock h={64} r={14} style={{ margin: "12px 14px 0", flexShrink: 0 }} />

      {/* 3 · 2×2 tile board — 3 stable tiles (my-tasks is conditional-late) */}
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10, margin: "10px 14px 0", flexShrink: 0 }}>
        <SkeletonBlock h={112} r={13} />
        <SkeletonBlock h={112} r={13} />
        <SkeletonBlock h={112} r={13} />
      </div>

      {/* 4 · composer dock (non-sticky mirror; bar only, no chips) */}
      <div
        style={{
          marginTop: "auto",
          flexShrink: 0,
          background: "var(--card)",
          borderTop: "1px solid var(--border)",
          padding: "10px 14px calc(14px + env(safe-area-inset-bottom))",
        }}
      >
        <SkeletonBlock h={54} r={13} />
      </div>
    </>
  );
}

export default DashboardSkeleton;
